import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import Controls from "../../../controls/Controls";
import { useForm, Form } from "../../../controls/useForm";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { request } from "../../../../api/Service";
import { toast } from "react-toastify";
import { store } from "../../../../redux-store/store";

const initialFValues = {
  userId: 0,
  currentPassword: "",
  confirmPassword: "",
  newPassword: "",
};

export default function ChangeUserPasswordForm(props) {
  const { addProductCategory, recordForEdit } = props;
  const [userP, setUserP] = useState("");
  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    if ("newPassword" in fieldValues) setUserP(fieldValues.newPassword);
    if ("newPassword" in fieldValues)
      temp.newPassword = fieldValues.newPassword ? "" : "Field is required";
    if ("confirmPassword" in fieldValues)
      temp.confirmPassword =
        fieldValues.confirmPassword === userP
          ? ""
          : "Confirm Password must be eual to New Password";
    if ("currentPassword" in fieldValues)
      temp.currentPassword = fieldValues.currentPassword
        ? ""
        : "Field is required";
    setErrors({
      ...temp,
    });
    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, true, validate);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      e.preventDefault();
      store.dispatch({ type: "DISPLAY_LOADER" });
      const { currentPassword, newPassword, confirmPassword } = initialFValues;

      request("post", values, `/api/Authentication/change-password`)
        .then((data) => {
          toast.success("Password Changed Successfully!!!");
          store.dispatch({ type: "DISPLAY_LOADER" });
          props.setOpenPopup(false);
        })
        .catch((error) => toast.error(error.response.data.message));
    }
  };

  useEffect(() => {
    if (recordForEdit !== null)
      setValues({
        ...recordForEdit,
      });
  }, [recordForEdit]);

  return (
    <Form onSubmit={handleSubmit}>
      <ToastContainer />
      <Grid container>
        <Controls.Input
          name="currentPassword"
          label="Current Password"
          value={values.currentPassword || ""}
          onChange={handleInputChange}
          error={errors.currentPassword}
        />

        <Controls.Input
          label="New Password"
          name="newPassword"
          value={values.newPassword || ""}
          onChange={handleInputChange}
          error={errors.newPassword}
        />
        <Controls.Input
          label="Confirm Password"
          name="confirmPassword"
          value={values.confirmPassword || ""}
          onChange={handleInputChange}
          error={errors.confirmPassword}
        />
        <div style={{ margin: "40px 10px 20px 300px" }}>
          <Controls.Button type="submit" text="Submit" />
        </div>
      </Grid>
    </Form>
  );
}
